import { Autocomplete, TextField } from "@mui/material";
import { Fragment, useEffect, useState } from "react";

const CommonAutocomplete = ({
  label,
  value,
  onSelect,
  width = 200,
  id,
  data = [],
  filterOptions,
  optionLabel,
  name,
  renderOption,
  sx,
  defaultValue,
  disabled,
  componentsProps,
}) => {
  const [highlightedOption, setHighlightedOption] = useState(null);
  return (
    <Fragment>
      <Autocomplete
        value={value || null}
        defaultValue={defaultValue || null}
        options={data}
        getOptionLabel={optionLabel}
        filterOptions={filterOptions}
        renderOption={renderOption}
        sx={{
          width: width,
          padding: 0,
          "& svg": {
            display: "none",
          },
          ...sx,
        }}
        autoHighlight={true}
        onChange={onSelect}
        id={id}
        name={name}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            name={name}
            InputProps={{
              ...params.InputProps,
              style: {
                fontSize: 16,
                textAlign: "center",
                height: "100%",
                paddingInline: 0,
              },
            }}
            InputLabelProps={{
              shrink: true,
              style: {
                fontSize: 20,
                fontWeight: 500,
                padding: 0,
              },
            }}
            sx={{ padding: 0, height: "100%" }}
            onKeyDownCapture={(e) => {
              if (e.key === "Enter" && e.location === 3 && !e.shiftKey) {
                onSelect(null, highlightedOption || value);
              }
            }}
            onChange={(e) => {
              const matchedOption = data.find(option => optionLabel(option).toLowerCase().includes(e.target.value.toLowerCase()));
              if (matchedOption) {
                setHighlightedOption(matchedOption);
              } else {
                setHighlightedOption(null);
              }
            }}
          />
        )}
        disabled={disabled}
        onHighlightChange={(event, option, reason) => {
          if (reason !== "mouse" && reason !== "auto") {
            setHighlightedOption(option);
          }
        }}
        onBlur={() => setHighlightedOption(null)}
        componentsProps={componentsProps}
      />
    </Fragment>
  );
};

export default CommonAutocomplete;
